import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { User } from '@core/generated/gql-types';
import { useJobApplicationStore } from '@core/jobApplication/useJobApplicationStore';
import JobApplicationItem from '@/components/jobApplication/JobApplicationItem';

const Applications = ({ worker }: { worker: User }) => {
  const [hasFetched, setHasFetched] = useState(false);
  const { fetchJobApplicationsForUser, getJobApplicationsForUser } =
    useJobApplicationStore();
  const jobApplicationsForUser = getJobApplicationsForUser(worker.id);

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        if (worker.id && !hasFetched) {
          await fetchJobApplicationsForUser(worker.id);
          setHasFetched(true);
        }
      } catch (error) {
        console.error(`Error getting job applications: ${error}`);
        toast.error(
          `Fetching job applications failed: ${error instanceof Error ? error.message : 'Error'}`,
          {
            position: 'bottom-left',
            autoClose: 5000,
            toastId: 'fetch-applications-error',
          },
        );
      }
    };

    fetchApplications();
  }, [worker.id, hasFetched, fetchJobApplicationsForUser]);

  return (
    <div className="rounded-lg bg-white p-6 shadow-sm">
      <h2 className="mb-4 text-xl font-semibold">Applications</h2>
      <div className="space-y-4">
        {jobApplicationsForUser.length > 0 ? (
          <div className="space-y-4">
            {jobApplicationsForUser.map((application) => (
              <JobApplicationItem
                key={application.id}
                application={application}
              />
            ))}
          </div>
        ) : (
          <p className="text-gray-500">No applications submitted yet</p>
        )}
      </div>
    </div>
  );
};

export default Applications;
